module.exports = __webpack_public_path__ + "img/no-permission.c85bdae3.png";